import { FC, ReactNode, useContext, useEffect } from 'react';
import { isBrowser } from '@agria/utils';
import { ExperimentsContext } from '../context/ExperimentsContext';

export interface ExperimentsWrapperProps {
  children: ReactNode;
  data: any; // TODO - does gatsby have a type for this??
}

export const ExperimentsWrapper: FC<ExperimentsWrapperProps> = ({
  children,
  data,
}) => {
  const { experiments, setExperiments } = useContext(ExperimentsContext);

  useEffect(() => {
    const waitForGlobal = function (key, callback) {
      if (window[key]) {
        callback();
      } else {
        setTimeout(() => {
          waitForGlobal(key, callback);
        }, 100);
      }
    };

    if (isBrowser) {
      waitForGlobal('experiments', () => {
        setExperiments((current) => ({
          ...current,
          ...window.experiments,
        }));
      });
    }
  }, [data, setExperiments]);

  if (isBrowser && experiments) {
    window.setExperiments = (newExperiments: Record<string, string>) => {
      const updatedExperiments = {
        ...experiments,
        ...newExperiments,
      };
      setExperiments(updatedExperiments);
      return updatedExperiments;
    };

    window.getExperiments = () => experiments;
  }

  return children;
};
